import React from "react";
import { CreateAdsProjectDialog } from "./create-ads-project-dialog";
import CreateIWProjectDialog from "./create-iw-project-dialog";
import CreateSAProjectDialog from "./create-sa-project-dialog";
import { CreateUAProjectDialog } from "./create-ua-project-dialog";

type BigQueryConfig = {
  id: string;
  projectID: string;
  datasetName: string;
  latestDataDate?: string;
};

type Props = {
  workspaceId: string;
  type: "iw" | "sa" | "ua" | "ads";
  trigger: React.ReactNode;
  searchAnalyticsBigQueries?: BigQueryConfig[];
  userAnalyticsBigQueries?: BigQueryConfig[];
  workspaceUsedColors?: string[];
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
};

export default function CreateProjectDialog({
  workspaceId,
  type,
  trigger,
  searchAnalyticsBigQueries = [],
  workspaceUsedColors,
  open,
  onOpenChange,
}: Props) {
  if (type === "iw") {
    return (
      <CreateIWProjectDialog
        workspaceId={workspaceId}
        trigger={trigger}
        workspaceUsedColors={workspaceUsedColors}
      />
    );
  }

  if (type === "sa") {
    return (
      <CreateSAProjectDialog
        workspaceId={workspaceId}
        trigger={trigger}
        searchAnalyticsBigQueries={searchAnalyticsBigQueries}
        workspaceUsedColors={workspaceUsedColors}
      />
    );
  }

  if (type === "ua") {
    return (
      <CreateUAProjectDialog
        workspaceId={workspaceId}
        trigger={trigger}
        open={open}
        onOpenChange={onOpenChange}
        workspaceUsedColors={workspaceUsedColors}
      />
    );
  }

  if (type === "ads") {
    return (
      <CreateAdsProjectDialog
        workspaceId={workspaceId}
        trigger={trigger}
        open={open}
        onOpenChange={onOpenChange}
        workspaceUsedColors={workspaceUsedColors}
      />
    );
  }

  return null;
}
